import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Table, theme } from 'antd';
import { AnyObject } from 'antd/lib/_util/type';

import type { ColumnsType, TableProps } from 'antd/lib/table';

import './CustomTable.scss';

const { useToken } = theme;
function CustomTable<DataType extends AnyObject>({
  dataSource,
  columns,
  rowKey,
  rowSelection,
  emptyText = '',
  paginationConfig = false,
  scroll = undefined,
  isLoading = false,
  className = '',
}: {
  className?: string;
  dataSource: DataType[];
  columns: ColumnsType<DataType>;
  rowKey: string | ((record: DataType) => string);
  rowSelection?: TableProps<DataType>['rowSelection'];
  paginationConfig:
    | {
        current?: number;
        onChange?: (page: number, pageSize: number) => void;
        total?: number;
        pageSize?: number;
        showTotal?: (total: number, range: [number, number]) => ReactNode;
        showSizeChanger?: boolean;
      }
    | false;
  emptyText?: string;
  scroll?: {
    scrollToFirstRowOnChange?: boolean;
    x?: string | number;
    y?: string | number;
  };
  isLoading?: boolean;
}) {
  const { token } = useToken();
  const { t } = useTranslation();

  const EmptyText = emptyText || t('Common.NoData');

  const fixPaginationConfig = {
    showSizeChanger: false,
    locale: { items_per_page: t('Common.RecordsPerPage') },
  };

  const finalPaginationConfig = paginationConfig
    ? { ...fixPaginationConfig, ...paginationConfig }
    : false;

  return (
    <div className="CustomTable" style={{ color: token.colorPrimary }}>
      <Table<DataType>
        className={`CustomTable__table ${className}`}
        dataSource={dataSource}
        columns={columns}
        rowKey={rowKey}
        rowSelection={rowSelection}
        pagination={finalPaginationConfig}
        scroll={scroll}
        locale={{ emptyText: EmptyText }}
        loading={isLoading}
      />
    </div>
  );
}

export default CustomTable;
